import * as React from "react";

import { BaseFormDisplay } from "components/form/legacyFields/formDisplay";

import * as T from "../../content/types";
import * as U from "../../content/utils";

import * as theme from "./theme.css";

class MetadataErrorWidget extends React.PureComponent<MetadataErrorWidgetProps> {
    render = () => {
        const { label, error } = this.props;
        return (
            <BaseFormDisplay label={label}>
                <div className={theme.error}>{U.instanceAsString(error)}</div>
            </BaseFormDisplay>
        );
    };
}

interface MetadataErrorWidgetProps {
    id: string;
    label: string;
    error: T.MetadataError;
}

export { MetadataErrorWidget, type MetadataErrorWidgetProps };
